<div *ngIf="dadosSegundaVia" class="boleto-container">
  <app-boleto-parcela 
    [showAlert]="showAlert"
    [dadosBoleto]="dadosSegundaVia">
  </app-boleto-parcela>

  <div class="banqi-container" *ngIf="false">
    <h2>Você conhece o BanQi?</h2>

    <div class="banqi-logo">
      <img src="../../assets/images/banqi-logo.svg" alt="banqi"/>
    </div>

    <div class="banqi-content">
      <p>Você pode acompanhar os pagamentos do seu carnê e realizar outras operações através do app BanQi, o banco digital parceiro da Casas Bahia.</p>
      <a 
        class="playstore-banqi" 
        href='https://play.google.com/store/apps/details?id=com.mgensuite.airfox.recharge&hl=pt_BR&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' 
        target="_blank" rel="noopener noreferrer">
        <img alt='Disponível no Google Play' src='https://play.google.com/intl/pt-BR/badges/static/images/badges/pt_badge_web_generic.png'/>
      </a>
    </div>
  </div>
</div>